var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 41,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 652"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -233.389,
    y: -195.16,
    width: 505.588,
    height: 347,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".File upload / Style / Modal / Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".File upload / Master / Modal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    filter: "url(#filter0_d_170_434)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -174.094,
    y: -35.6602,
    width: 387,
    height: 147,
    rx: 5.5,
    stroke: "#18191C",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -174.094,
    y: -35.6602,
    width: 387,
    height: 147,
    rx: 5.5,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -174.094,
    y: -35.6602,
    width: 387,
    height: 147,
    rx: 5.5,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -174.094,
    y: -35.6602,
    width: 387,
    height: 147,
    rx: 5.5,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -174.094,
    y: -35.6602,
    width: 387,
    height: 147,
    rx: 5.5,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -174.094,
    y: -35.6602,
    width: 387,
    height: 147,
    rx: 5.5,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -174.094,
    y: -35.6602,
    width: 387,
    height: 147,
    rx: 5.5,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -174.094,
    y: -35.6602,
    width: 387,
    height: 147,
    rx: 5.5,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.3164 5.10175C38.3164 1.94887 36.7224 0.349869 33.5796 0.344856L26.3264 0.339844C21.1986 0.339844 16.0708 0.346527 10.9446 0.358223C7.92209 0.366577 6.32309 1.98563 6.31808 5.03993L6.31641 26.1327C6.31641 26.5019 6.61716 26.801 6.98474 26.801C7.35233 26.801 7.65308 26.5002 7.65308 26.1327L7.65642 5.03993C7.65809 2.70242 8.64389 1.70158 10.948 1.69657C16.0741 1.68487 21.1986 1.67819 26.3264 1.67819L33.5796 1.6832C35.9939 1.68487 36.9781 2.67568 36.9781 5.10175L36.9797 21.6698L36.9781 29.2254L32.9079 29.2221C30.6806 29.2053 29.2304 29.2003 28.1577 30.2663C27.1903 31.2254 26.9948 32.6807 26.9898 34.7191V38.9647L12.3933 38.9731C12.024 38.9731 11.7249 39.2738 11.7249 39.6414C11.7249 40.009 12.0257 40.3098 12.3933 40.3098H16.1577L27.6581 40.3014C28.0407 40.3014 28.4183 40.1477 28.689 39.882C32.7141 35.9589 37.3273 31.4911 37.7132 31.1485C37.74 31.1285 37.8553 31.0299 37.8786 31.0065C38.156 30.7325 38.3164 30.3499 38.3164 29.9589V29.9004C38.3164 29.8971 38.3181 29.8954 38.3181 29.8921C38.3181 29.8887 38.3164 29.887 38.3164 29.8837L38.3181 21.6665L38.3164 5.10175ZM28.3281 38.3231V34.7225C28.3298 33.0266 28.4601 31.8503 29.1 31.2154C29.7517 30.5688 30.7358 30.542 32.9179 30.5604L36.3916 30.5621C35.0115 31.872 31.1786 35.588 28.3281 38.3231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.8695 26.8001C17.9965 26.8001 18.1235 26.7634 18.2354 26.6915L27.1327 20.8853C27.3215 20.7617 27.4368 20.5512 27.4368 20.3256C27.4368 20.1 27.3231 19.8895 27.1327 19.7659L18.2354 13.9597C18.0299 13.826 17.7676 13.816 17.552 13.9313C17.3365 14.0466 17.2012 14.2738 17.2012 14.5194V26.1301C17.2012 26.374 17.3365 26.6013 17.552 26.7182C17.6506 26.7734 17.7592 26.8001 17.8695 26.8001ZM18.5378 15.7542L25.542 20.3256L18.5378 24.897V15.7542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 28",
    d: "M17.9336 25.8086V15.0547L26.7823 20.2794L17.9336 25.8086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.98537 27.3574C3.40642 27.3574 0.494141 30.2697 0.494141 33.8486C0.494141 37.4276 3.40642 40.3399 6.98537 40.3399C10.5643 40.3399 13.4766 37.4276 13.4766 33.8486C13.4766 30.2697 10.5643 27.3574 6.98537 27.3574ZM6.98537 39.0015C4.14326 39.0015 1.83249 36.6908 1.83249 33.8486C1.83249 31.0065 4.14326 28.6958 6.98537 28.6958C9.82747 28.6958 12.1383 31.0065 12.1383 33.8486C12.1383 36.6908 9.82747 39.0015 6.98537 39.0015Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.48442 29.7203C7.48108 29.7169 7.47607 29.7153 7.47105 29.7102C7.46437 29.7019 7.45602 29.6952 7.44933 29.6885C7.44599 29.6852 7.44432 29.6802 7.43931 29.6752C7.41592 29.6534 7.38584 29.6451 7.35911 29.6267C7.3541 29.6234 7.34741 29.6183 7.3424 29.615C7.314 29.5966 7.28893 29.5716 7.25886 29.5582C7.24883 29.5532 7.23714 29.5515 7.22711 29.5465C7.19035 29.5331 7.15359 29.5298 7.11684 29.5231C7.08008 29.5164 7.04499 29.5031 7.00656 29.5014C7.00155 29.5014 6.99653 29.498 6.98985 29.498C6.98317 29.498 6.97816 29.5014 6.97314 29.5014C6.93471 29.5031 6.89963 29.5148 6.86287 29.5231C6.82444 29.5298 6.78601 29.5331 6.74925 29.5465C6.73923 29.5498 6.7292 29.5532 6.72085 29.5565C6.68743 29.5716 6.6607 29.5966 6.63062 29.6167L6.62561 29.62C6.5972 29.6384 6.56546 29.6484 6.53872 29.6718C6.53538 29.6752 6.53371 29.6802 6.5287 29.6852C6.52034 29.6919 6.51366 29.7002 6.50698 29.7069C6.50364 29.7102 6.49862 29.7119 6.49361 29.7169L3.93555 32.5223C3.68826 32.7946 3.70664 33.2173 3.97899 33.4663C4.10765 33.5816 4.26805 33.6401 4.43012 33.6401C4.61057 33.6401 4.79269 33.5666 4.92469 33.4212L6.31984 31.8924V37.5198C6.31984 37.889 6.62059 38.1881 6.98818 38.1881C7.35577 38.1881 7.65652 37.8874 7.65652 37.5198V31.8907L9.04165 33.4078C9.17364 33.5532 9.35577 33.6267 9.53622 33.6267C9.69829 33.6267 9.85869 33.5682 9.98735 33.4513C10.2597 33.204 10.2797 32.7813 10.0308 32.5089L7.48442 29.7203Z",
    fill: "#1D1D1D"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_170_434",
    x: -176.594,
    y: -37.1602,
    width: 392,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_170_434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_170_434",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/video_upload.62ae33dfdedafe6fc558ccf784ef9842.svg";
export { ForwardRef as ReactComponent };